export default function VideoEmbed({ url, title = "Video" }) {
  if (!url) return null;
  let embed = null;

  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{6,})/);
  const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  const rumble = url.match(/rumble\.com\/(?:embed\/)?([\w.-]+)/);

  if (yt) embed = `https://www.youtube.com/embed/${yt[1]}`;
  else if (vimeo) embed = `https://player.vimeo.com/video/${vimeo[1]}`;
  else if (/\.(mp4|webm|ogg)(\?.*)?$/i.test(url)) {
    return (
      <video controls className="w-full rounded-2xl aspect-video bg-black" data-testid="video-direct">
        <source src={url} />
      </video>
    );
  } else if (rumble) embed = url.includes("/embed/") ? url : null;

  if (!embed) return <p className="text-sm text-stone-500">Unsupported or invalid video URL.</p>;

  return (
    <div className="relative w-full overflow-hidden rounded-2xl shadow-md aspect-video bg-black">
      <iframe
        src={embed} title={title} loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen className="absolute inset-0 w-full h-full"
      />
    </div>
  );
}
